export function mobileNumberValidation(locale) {
  switch (locale) {
  case 'AU':
    return 'auMobileNumber';
  case 'en-GB':
    return 'ukMobileNumber';
  default:
    return 'auMobileNumber';
  }
}
